import { Component, ElementRef, ViewChild } from '@angular/core';

import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './url-form-field.component.html',
  styles: [
    `
      .mat-form-field {
        button {
          .mat-icon {
            min-width: 5px;
            width: 18px;
            min-height: 5px;
            height: 18px;
          }
        }
      }

      mat-form-field {
        input {
          &:focus {
            opacity: 1;
          }
        }
      }

      .remove-email-field-url {
        visibility: hidden;
      }
      .url-wrapper:hover .remove-email-field-url {
        visibility: visible;
      }
      .readonly {
        color: #6e6e6e !important;
      }
      input.blurred {
        filter: blur(2px);
        font-style: italic;
        letter-spacing: 2px;
      }
    `,
  ],
})
export class UrlFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  public editing: boolean = false;
  public value: string;
  private _originalValue: string;
  private _readonly: boolean;

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.fieldDef.meta?.value_hidden && !this.editing ? 'REDACTED' : this.model[this.fieldDef.name];
    this._originalValue = this.value;

    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this._readonly = this.fieldDef.meta.readonly;
    }
    if (this.readonly) {
      this._readonly = this.readonly;
    }
    this.readonly = this._readonly;
  }

  edit(): void {
    if (!this.editing && !this._readonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl.nativeElement.focus();
      }, 300);
    }
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  visitUrl(): void {
    window.open(this.value);
  }

  updateChangedModel(model: any): void {}

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }
}
